import BtnSimpl from '../../components/buttons/BtnSimpl';
import { Col, Form, Input, notification, Row, Spin,  } from 'antd';
import Title from 'antd/es/typography/Title';
import logoUniversite from "../../assets/img/logo-ussd-1.jpg";
import "./auth.css";
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../../redux/actions/ResetPasswordActions';


const ResetPassword = () => {
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const { token } = useParams();
       
  const { loading:loadinResetPwd, error } = useSelector((state) => state.resetPassword);

  const handleResetPassword = async (values) => {
  const { newPassword, confirmPassword } = values;

  if (newPassword !== confirmPassword) {
    notification.warning({
      message: "Les mots de passe ne correspondent pas.",
      duration: 7,
    });
    return;
  }

  const PasswordData = {
    newPassword,
    token,
  };

  const response = await dispatch(resetPassword(PasswordData));
  if (response) {
    form.resetFields();
    navigate("/");
  }
};

   
    return (
                <Row justify="center" className='divGlobal'>
                    <Col span={12} className='colGlobal'>
                    
                        <img style={{width:"25%", height:"23%" , marginBottom:"-1%", }} src={logoUniversite} alt="logoussd" />
                        <Title level={2} style={{marginBottom:"6%"}} >Définir un nouveau mot de passe</Title>

                        <Form onFinish={handleResetPassword} form={form} style={{width:"80%", margin:"0 auto"}}>
                            <Form.Item name="newPassword" rules={[{ required: true, message: "Champ obligatoire" }]} >
                                <Input.Password placeholder="Nouveau mot de passe" style={{padding:"3%", fontSize:"18px", }} />
                            </Form.Item>

                            <Form.Item name="confirmPassword" rules={[{ required: true, message: "Champ obligatoire" }]}>
                                <Input.Password placeholder="Confirmer mot de passe" style={{padding:"3%", fontSize:"18px", }} />
                            </Form.Item>

                            {error && <p style={{ color: "red", textAlign:"center", marginTop:"-3.5%" }}>{error}</p>}
                             
                             <Form.Item>
                              <Spin className="spinLoading" spinning={loadinResetPwd} tip="Connexion en cours..." size="small">
                            <BtnSimpl buttonText_="Enregistrer"  backgroundColor_="#43CE0C" 
                            width_="100%" padding_="7.2%"  htmlType_="submit" borderRadius_="0.5rem" border_={true}
                            color_="#ffffff" boldColor_={600} fontSize_="18px" 
                            disabled_= {loadinResetPwd} 
                            />
                            </Spin>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
    );
};

export default ResetPassword;